export const exportHeaders = [
    {
        label: "User Name",
        key: "user_name"
    },

    {
        label: "Previous Login",
        key: "old_login"
    },


    {
        label: "Latest Login",
        key: "new_login"
    },

    {
        label: "Initiated By",
        key: "altered_by"
    },

   

    
]